import { Stack } from 'components';

import style from './branch.module.scss';

const Branch = ({ children, label }: { children?: React.ReactNode; label: React.ReactNode }) => {
  return (
    <Stack ml="10px !important" pl="26px" position="relative" className={style.verticalBranch}>
      <Stack position="relative" className={style.branch}>
        {label}
      </Stack>
      {children}
    </Stack>
  );
};

export default Branch;
